import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../components";
import { colors } from "../../../consts";

export const CampaignsCounterContainer = styled(WrapperContainer)`
  height: 23px;
  min-width: 23px;
  margin-left: 8px;
  padding: 0 8px;
  border-radius: 70px;
  background: ${colors.ISABELLINE_DARKER};

  ${Paragraph2} {
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    color: ${colors.RAISIN_80};
  }
`;
